import { makeStyles } from '@material-ui/styles';
import { FilledVideoCamera, Text, Theme } from '@bizzabo/design-system';
import { UserPreview, UserData } from '@bizzabo/entities';
import DeclineButton from '../DeclineButton';
import JoinButton from '../JoinButton';
import { Avatar } from '@bizzabo/collaboration-common';
export interface VideoSmallNotificationProps {
    isDesktop: boolean;
    currentUser: UserData;
    callerUser: UserPreview;
}

const VideoSmallNotification: React.FC<VideoSmallNotificationProps> = ({
    callerUser,
    currentUser,
    isDesktop,
}) => {
    const classes = useStyles({ isDesktop });

    const text = isDesktop
        ? `Meeting invite from ${callerUser?.firstName}`
        : `${callerUser?.firstName}'s meeting`;
    return (
        <>
            <div className={classes.userDetails}>
                <Avatar
                    src={callerUser?.photoUrl}
                    size={36}
                    badge={<FilledVideoCamera title={'filled-video-icon'} />}
                />
                <Text variant="t61" className={classes.text}>
                    {text}
                </Text>
            </div>
            <div className={classes.buttons}>
                <DeclineButton isDesktop={isDesktop} isLarge={false} />
                <JoinButton currentUser={currentUser} />
            </div>
        </>
    );
};

const useStyles = makeStyles<Theme, { isDesktop: boolean }>(
    theme => ({
        userDetails: {
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
        },
        text: {
            color: theme.palette.greys[100],
            margin: '0px 16px',
            maxWidth: ({ isDesktop }) => (isDesktop ? 220 : 130),
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        buttons: {
            display: 'flex',
        },
    }),
    { classNamePrefix: 'video-notification-small-notification' }
);

export default VideoSmallNotification;
